import { useEffect, useState } from "react";

const useMemberLeft = ({ channelInformation }) => {
  const [member, setMember] = useState();
  useEffect(() => {
    if (channelInformation !== undefined) {
      channelInformation.on("participantLeft", (member) => {
        setMember(member);
      });
    }

    //eslint-disable-next-line
  }, [channelInformation]);

  return { member };
};

export default useMemberLeft;
